import {
  SectionedHorizontalLinedTable,
  SwitchAppButton,
} from "../../components";
import { SectionedHeader } from "../../components/SectionedHorizontalLinedTable/SectionedHeader";
import { ActivationRequiredWarning } from "../../components";
import { PageTabNavLinks } from "../../components";
import { Routes, Route, Outlet } from "react-router-dom";
import { Reciept } from "./Reciept";
import { ExtendedLeftRightSection } from "../../components/SectionedHorizontalLinedTable/ExtendedLeftRightSection";
import paystack from "../../assets/icons/paystack.svg";
import SwitchLogo from "../../assets/images/switchapp-logo.svg";

import visa from "../../assets/icons/visa.png";
import mcard from "../../assets/icons/mcard.png";
import Amex from "../../assets/icons/amex.png";
import Discover from "../../assets/icons/Discover.png";

import card from "../../assets/icons/card.svg";
import bank from "../../assets/icons/bank.svg";
import ussd from "../../assets/icons/ussd.svg";
import code from "../../assets/icons/code.svg";
import { IBrandingSettings, IHookForm } from "../../interfaces-and-types";
import { DevTool } from "@hookform/devtools";
import { DefaultLogo } from "./DefaultLogo";
import { HookFormFileUpload, SubmitButton } from "../../hook-form";

export const View = ({
  goBack,
  isDirty,
  control,
  logoActualImage,
  saveMerchantLogo,
  handleSubmit,
  errors,
  register,
}: IHookForm<IBrandingSettings> & {
  goBack: () => void;
  isDirty: boolean;
  saveMerchantLogo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  logoActualImage?: string;
}) => {
  return (
    <>
      <form onSubmit={handleSubmit}>
        <ActivationRequiredWarning
          title="Please you need to activate your profile"
          subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
          urlTarget="/onboarding"
        />

        <SectionedHorizontalLinedTable>
          <SectionedHeader
            hasBorder={true}
            mainHead="Brand customization"
            subHead="Customize how your brand appears globally across the SwitchApp products your customers use"
          />

          <div className="brand-cont">
            <div className="brand-left">
              <div className="div brand-section-title">Brand elements</div>
              <div className="div">
                <div className="flex-container row justify-content--between">
                  <HookFormFileUpload
                    name="merchant_logo"
                    buttonLabel="Upload Merchant Logo"
                    label="Merchant Logo"
                    labelTitle="Logo thumbnail"
                    register={register}
                    errors={errors}
                    className="file-upload-for-product"
                    onChange={(e: any) => {
                      saveMerchantLogo(e);
                      // (e: React.ChangeEvent<HTMLInputElement>) =>
                      // console.log(
                      //   "File Selected: ",
                      //   e.target?.files ? e.target?.files[0] : ""
                      // )
                    }}
                  />

                  {/* <MerchantLogoImageUpload
                    placeholder="Registered business name"
                    labelText="Business Logo"
                    helperText="Upload Logo"
                    className="lr-input-style"
                    is_disabled={false}
                  /> */}

                  <div className="preview-container--logo">
                    <img
                      alt="logo preview"
                      className="image-previewer"
                      src={logoActualImage}
                    />
                  </div>
                </div>
              </div>
              <div className="div flex-container col gap-2">
                <div className="flex-container hundred align-items--center justify-content--start row gap-1">
                  <div className="fty-fty">Brand color</div>
                  <div className="flex-container gap-1 align-items--center">
                    <input
                      {...register("brand_color")}
                      type="color"
                      className="colored-box brand"
                      aria-label="brand color input"
                      onChange={(e) => {
                        (
                          document.querySelector(
                            ".brand-color"
                          )! as HTMLInputElement
                        ).value = e.target.value;
                        (
                          document.querySelector(
                            ".main-top"
                          )! as HTMLInputElement
                        ).style.backgroundColor = e.target.value;

                        (
                          document.querySelector(
                            ".active-brand-option"
                          )! as HTMLInputElement
                        ).style.backgroundColor = e.target.value + "80";
                        (
                          document.querySelector(
                            ".active-brand-option"
                          )! as HTMLInputElement
                        ).style.fontWeight = "700";
                      }}
                    />
                    <input
                      {...register("brand_color")}
                      className="brand-input brand-color"
                      aria-label="brand color value"
                      onChange={(e) => {
                        (
                          document.querySelector(".brand")! as HTMLInputElement
                        ).value = e.target.value;
                        (
                          document.querySelector(
                            ".main-top"
                          )! as HTMLInputElement
                        ).style.backgroundColor = e.target.value;
                      }}
                    />
                  </div>
                </div>
                <div className="flex-container hundred align-items--center justify-content--start row gap-1">
                  <div className="fty-fty">Text color</div>
                  <div className="flex-container gap-1 align-items--center">
                    <input
                      {...register("text_color")}
                      type="color"
                      className="colored-box text"
                      onChange={(e) => {
                        (
                          document.querySelector(
                            ".text-color"
                          )! as HTMLInputElement
                        ).value = e.target.value;
                        (
                          document.querySelector(
                            ".main-top"
                          )! as HTMLInputElement
                        ).style.color = e.target.value;

                        (
                          document.querySelector(
                            ".active-brand-option"
                          )! as HTMLInputElement
                        ).style.color = e.target.value;
                      }}
                    />
                    <input
                      {...register("text_color")}
                      className="brand-input text-color"
                      onChange={(e) => {
                        (
                          document.querySelector(".text")! as HTMLInputElement
                        ).value = e.target.value;
                        (
                          document.querySelector(
                            ".main-top"
                          )! as HTMLInputElement
                        ).style.color = e.target.value;

                        (
                          document.querySelector(
                            ".active-brand-option"
                          )! as HTMLInputElement
                        ).style.color = e.target.value;
                      }}
                    />
                  </div>
                </div>
                <div className="flex-container hundred align-items--center justify-content--start row gap-1">
                  <div className="fty-fty">Accent color</div>
                  <div className="flex-container gap-1 align-items--cente">
                    <input
                      {...register("accent_color")}
                      type="color"
                      className="colored-box accent"
                      onChange={(e) => {
                        (
                          document.querySelector(
                            ".accent-color"
                          )! as HTMLInputElement
                        ).value = e.target.value;

                        (
                          document.querySelector(
                            ".accent-brand"
                          )! as HTMLInputElement
                        ).style.backgroundColor = e.target.value;
                      }}
                    />
                    <input
                      {...register("accent_color")}
                      className="brand-input accent-color"
                      onChange={(e) => {
                        (
                          document.querySelector(".accent")! as HTMLInputElement
                        ).value = e.target.value;

                        (
                          document.querySelector(
                            ".accent-brand"
                          )! as HTMLInputElement
                        ).style.backgroundColor = e.target.value;
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="button-group">
                <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
                  Cancel
                </SwitchAppButton>
                <SubmitButton
                  size="sm"
                  // disabled={!isDirty}
                  showChildrenWithLoadingIcon
                >
                  Save
                </SubmitButton>
              </div>
            </div>
            <div className="brand-right flex-container gap-1 col">
              <div className="brand-section-title">Previews</div>
              <div className="div iframe">
                <div className="frame-nav">
                  <PageTabNavLinks
                    pageTabNavLinks={[
                      {
                        name: "Reciepts",
                        route: "reciept",
                      },
                      {
                        name: "Checkout and payment links",
                        route: "checkout-and-payment-links",
                      },
                      {
                        name: "Invoice",
                        route: "invoices",
                      },
                    ]}
                    boundedUnderline
                  />

                  <Outlet />
                </div>
                <div>
                  <Routes>
                    <Route
                      path="reciept"
                      element={
                        <Reciept
                          // backgroundColor={"#000000"}
                          topLeft={
                            <div className="flex-container row gap-1 justify-content--center align-items--center">
                              {logoActualImage ? (
                                <img
                                  alt="merchant logo"
                                  src={logoActualImage}
                                  className="merchant-logo"
                                />
                              ) : (
                                <DefaultLogo />
                              )}

                              <div>Tech Store</div>
                            </div>
                          }
                          topRight={
                            <div className="flex-container justify-content--center col align-items--end">
                              <div>Customer Name</div>
                              <div>customer-email@gmail.com</div>
                            </div>
                          }
                          mainTitle={
                            <div className="main-main-text">
                              Payment recieved
                            </div>
                          }
                          subTitle={
                            <div className="main-sub-text">
                              Reciept from Tech store
                            </div>
                          }
                          extraPhrase={
                            <div className="main-extra-text">
                              reciept no we234te42t4grt42t
                            </div>
                          }
                          middletext="Transaction details"
                          mainPage={
                            <div>
                              <ExtendedLeftRightSection
                                leftText="Amount paid"
                                rightText="$ 5,000"
                                hasBorder={false}
                              />
                              <ExtendedLeftRightSection
                                leftText="Payment gateway"
                                rightText={
                                  <div className="paystack-with-text">
                                    <img alt="paystack logo" src={paystack} />{" "}
                                    <strong>Paystack</strong>
                                  </div>
                                }
                                hasBorder={false}
                              />
                              <ExtendedLeftRightSection
                                leftText="Invoice number"
                                rightText="$ 5,000"
                                hasBorder={false}
                              />

                              <ExtendedLeftRightSection
                                leftText="Date"
                                rightText="07 June 2022"
                                hasBorder={false}
                              />
                              <div className="flex-container col gap-2">
                                <strong>Summary</strong>
                                <div className="flex-container col gap-1 p-2 bg-white border-sm rounded-sm">
                                  <div className="flex-container justify-content--between align-items--center">
                                    <strong>iMac and other accessories</strong>
                                    <div> $ 4,899</div>
                                  </div>

                                  <div className="flex-container justify-content--between align-items--center">
                                    <strong>Tax</strong>
                                    <div> $ 101</div>
                                  </div>
                                  <div className="flex-divider--horizontal"></div>

                                  <div className="flex-container justify-content--between align-items--center">
                                    <strong>Total</strong>
                                    <div> $ 5,000</div>
                                  </div>
                                </div>
                              </div>

                              <div className="flex-container mt--2 align-items--center justify-content--center col gap-10">
                                <strong>Tech Store</strong>
                                <div>Got questions? Contact us at</div>
                                <a href="#">hello@techstore.com.ng</a>
                              </div>
                            </div>
                          }
                        />
                      }
                    />
                    {/* <Route path="/checkout-and-payment-links" element={<Transactions />} />
                  <Route path="/invoices" element={<Invoices />} /> */}

                    <Route
                      path="checkout-and-payment-links"
                      element={
                        <Reciept
                          // backgroundColor={"#000000"}
                          topLeft={
                            <div className="flex-container row gap-1 justify-content--center align-items--center">
                              {logoActualImage ? (
                                <img
                                  alt="merchant logo"
                                  src={logoActualImage}
                                  className="merchant-logo"
                                />
                              ) : (
                                <DefaultLogo />
                              )}
                              <div className="flex-container justify-content--center col align-items--end">
                                <div>Tech Store</div>
                                <div>Limited</div>
                              </div>
                            </div>
                          }
                          topRight={
                            <div className="flex-container row gap-1 justify-content--center align-items--center">
                              <img
                                alt="switchapp logo"
                                src={SwitchLogo}
                                className="switchapp-logo"
                              />
                            </div>
                          }
                          mainTitle={
                            <div className="main-main-text">$ 4,899</div>
                          }
                          subTitle={""}
                          extraPhrase="iMac and other accessories"
                          middletext=""
                          mainPage={
                            <div className="flex-container row">
                              <div className="flex-container col left-checkout">
                                <div className="title">PAY WITH</div>
                                <div
                                  style={{
                                    backgroundColor: (document.querySelector(
                                      ".brand"
                                    )! as HTMLInputElement)
                                      ? (
                                          document.querySelector(
                                            ".brand"
                                          )! as HTMLInputElement
                                        ).value + "80"
                                      : "",
                                    color: (document.querySelector(
                                      ".text-color"
                                    )! as HTMLInputElement)
                                      ? (
                                          document.querySelector(
                                            ".text-color"
                                          )! as HTMLInputElement
                                        ).value
                                      : "",
                                  }}
                                  className="options active-brand-option"
                                >
                                  <img alt="card" src={card} />
                                  Card
                                </div>
                                <div className="options">
                                  <img alt="bank" src={bank} />
                                  Bank Transfer
                                </div>
                                <div className="options">
                                  <img alt="ussd" src={ussd} />
                                  USSD
                                </div>
                                <div className="options">
                                  <img alt="gateway" src={card} />
                                  Payment Gateway
                                </div>
                                <div className="options">
                                  <img alt="qr code" src={code} />
                                  QR Code
                                </div>
                                <div className="options">
                                  <img alt="wallet" src={bank} />
                                  Wallet
                                </div>
                              </div>
                              <div className="flex-container col right-checkout gap-3">
                                <div className="flex-container col gap-1">
                                  <small>Email</small>
                                  <input title="email" className="input" />
                                </div>

                                <div className="flex-container col gap-1">
                                  <small>Card information</small>
                                  <div className=" card-info ">
                                    <div className="flex-container row top">
                                      <input placeholder="4587 4587 4687 4587" />
                                      <div className="flexed-icon">
                                        <img alt="visa" src={visa} />
                                        <img alt="mastercard" src={mcard} />
                                        <img alt="discover" src={Discover} />
                                        <img alt="amex" src={Amex} />
                                      </div>
                                    </div>
                                    <div className="flex-container row bottom">
                                      <input placeholder="MM/YY" />
                                      {/* <div className="flex-divider--vertical"></div> */}
                                      <input placeholder="CVV" />
                                    </div>
                                  </div>
                                </div>

                                <div className="flex-container col gap-1">
                                  <small>Name on card</small>
                                  <input
                                    title="name on card"
                                    className="input"
                                  />
                                </div>

                                <button
                                  style={{
                                    backgroundColor: (document.querySelector(
                                      ".accent"
                                    )! as HTMLInputElement)
                                      ? (
                                          document.querySelector(
                                            ".accent"
                                          )! as HTMLInputElement
                                        ).value
                                      : "",
                                    color: "white",
                                  }}
                                  className="accent-brand"
                                >
                                  Pay $4,899
                                </button>
                              </div>
                            </div>
                          }
                        />

                        //
                      }
                    />

                    <Route
                      path="invoices"
                      element={
                        <Reciept
                          topLeft={
                            <div className="flex-container row gap-1 justify-content--center align-items--center">
                              {logoActualImage ? (
                                <img
                                  alt="merchant logo"
                                  src={logoActualImage}
                                  className="merchant-logo"
                                />
                              ) : (
                                <DefaultLogo />
                              )}

                              <div>Tech Store</div>
                            </div>
                          }
                          topRight={
                            <div className="flex-container justify-content--center col align-items--end">
                              <div>Bodunde David</div>
                              <div>davidbodunde@gmail.com</div>
                            </div>
                          }
                          mainTitle={
                            <div className="main-main-text">$ 4,899</div>
                          }
                          subTitle={
                            <div className="main-sub-text">
                              Invoice from Tech store
                            </div>
                          }
                          extraPhrase={
                            <div className="main-extra-text">
                              Invoice no we234te 42t4gr t42 t
                            </div>
                          }
                          middletext="Invoice details"
                          mainPage={
                            <div>
                              <ExtendedLeftRightSection
                                leftText="Invoice number"
                                rightText="STA-38477DGK-Y7UI8"
                                hasBorder={false}
                              />
                              <ExtendedLeftRightSection
                                leftText="Due date"
                                rightText="07 September 2022"
                                hasBorder={false}
                              />
                              <div className="flex-container col gap-2">
                                <strong>Summary</strong>
                                <div className="flex-container col gap-1 p-2 bg-white border-sm rounded-sm">
                                  <div className="flex-container justify-content--between align-items--center">
                                    <strong>iMac and other accessories</strong>
                                    <div> $ 4,899</div>
                                  </div>

                                  <div className="flex-container justify-content--between align-items--center">
                                    <strong>Tax</strong>
                                    <div> $ 101</div>
                                  </div>
                                  <div className="flex-divider--horizontal"></div>

                                  <div className="flex-container justify-content--between align-items--center">
                                    <strong>Total</strong>
                                    <div> $ 5,000</div>
                                  </div>
                                </div>
                              </div>

                              <button
                                style={{
                                  backgroundColor: (document.querySelector(
                                    ".accent"
                                  )! as HTMLInputElement)
                                    ? (
                                        document.querySelector(
                                          ".accent"
                                        )! as HTMLInputElement
                                      ).value
                                    : "",
                                  color: "white",
                                }}
                                className="accent-brand"
                              >
                                Pay this invoice
                              </button>

                              <div className="flex-container mt--2 align-items--center justify-content--center col gap-10">
                                <strong>Tech Store</strong>
                                <div>Got questions? Contact us at</div>
                                <a href="#">hello@techstore.com.ng</a>
                              </div>
                            </div>
                          }
                        />
                      }
                    />
                  </Routes>
                </div>
              </div>
            </div>
          </div>
        </SectionedHorizontalLinedTable>
      </form>
      <DevTool control={control} /> {/* set up the dev tool */}
    </>
  );
};
